<template>
	<div full-height grey-back>

        <v-toolbar flat fixed>
            <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
            <v-toolbar-title class="white--text">Profile Settings</v-toolbar-title>
        </v-toolbar>

    	<div class="hasToolbar">

            <v-list nopadding two-line>
              
                <v-list-tile v-ripple @click="fn_updateBusiness">

                    <v-list-tile-action>
                        <v-icon class="primary-color">edit</v-icon>
                    </v-list-tile-action>

                    <v-list-tile-content>
                        <v-list-tile-title>User Profile</v-list-tile-title>
                        <v-list-tile-sub-title>Edit/Update user details</v-list-tile-sub-title>
                    </v-list-tile-content>

                    <v-list-tile-action>
                        <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                    </v-list-tile-action>
                
                </v-list-tile>

                <v-divider></v-divider>

                <v-list-tile v-ripple @click="fn_changeUserType">

                    <v-list-tile-action>
                        <v-icon color="primary">sync</v-icon>
                    </v-list-tile-action>

                    <v-list-tile-content>
                        <v-list-tile-title>Change User Type</v-list-tile-title>
                        <v-list-tile-sub-title>Update user type from accountant to business owner</v-list-tile-sub-title>
                    </v-list-tile-content>

                    <v-list-tile-action>
                        <v-icon color="primary">keyboard_arrow_right</v-icon>
                    </v-list-tile-action>
                </v-list-tile>

                <!-- <v-divider></v-divider>

                <v-list-tile v-ripple @click="fn_updateBusiness('register')">

                    <v-list-tile-action>
                        <v-icon color="primary">business</v-icon>
                    </v-list-tile-action>

                    <v-list-tile-content>
                        <v-list-tile-title>Register Business</v-list-tile-title>
                        <v-list-tile-sub-title>Create new business and manage accounting/billing</v-list-tile-sub-title>
                    </v-list-tile-content>

                    <v-list-tile-action>
                        <v-icon color="primary">keyboard_arrow_right</v-icon>
                    </v-list-tile-action>
                </v-list-tile> -->

                <v-divider></v-divider>

                <v-list-tile v-ripple @click="fn_changeNumber">

                    <v-list-tile-action>
                        <v-icon class="primary-color">smartphone</v-icon>
                    </v-list-tile-action>

                    <v-list-tile-content>
                        <v-list-tile-title>Change Number</v-list-tile-title>
                        <v-list-tile-sub-title>Update admin/login mobile number</v-list-tile-sub-title>
                    </v-list-tile-content>

                    <v-list-tile-action>
                        <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                    </v-list-tile-action>
                
                </v-list-tile>
                

            </v-list>

            <!-- <input type="file" id="logo" accept="image/*" style="visibility:hidden;"> -->

        </div>

        <dialog-confirmation ref="ref_dialogConfirmation" :header="confirmationHeader" :confirmationMessage="confirmationMessage" :actionMethod="actionMethod"></dialog-confirmation>

        <dialog-business-name ref="ref_dialogBusinessName"></dialog-business-name>
       
	</div>
</template>

<script>
// const dialogjs =  require('../../masters/forms/dialog').dialogjs;
// import dialogConfirmation from '../../dialogs/dialog_confirmation'
// import dialogBusinessName from '../../dialogs/dialog_business_name'

  export default{

    data(){
        return{
            base64Image:null,
            formId:null,
            dialogStorageId:null,
            confirmationHeader:null,
            confirmationMessage:null,
            actionMethod:null
        }
    },
    // components:{
    //     'dialog-confirmation': dialogConfirmation,
    //     'dialog-business-name': dialogBusinessName
    // },
    methods:{

        fn_changeUserType: function(){
            this.$router.push({path:"/registration/business/usertype"});
        },

        fn_updateBusiness: function(type){
            if(type=='register'){
                this.$router.push({path:'/registration/business/'+this.$root.CurrentBusiness.BusinessID+'/edit', query:{usertype:this.$root.CurrentBusiness.UserType}});
            }
            else{
                this.$router.push({path:'/registration/business/'+this.$root.CurrentBusiness.BusinessID+'/edit'});
            }
        },

        fn_changeNumber: function(){
            if(!navigator.onLine){
                this.showToast('Internet not available');
                return;
            }
            this.fn_openSecurityLock();
        },

        fn_openSecurityLock: function(){
            let self = this;
            this.getData('VerifyScreenLock', null, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        // self.fn_openDialogMatchBusiness();
                        let status = JSON.parse(response);
                        if(status){
                            self.fn_confirmChangeNumber();
                        }
                    },
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },

        fn_confirmChangeNumber: function(){
            let self = this;
            setTimeout(function(){
                self.$router.push({path:"/registration/business/change_phone_number"});
            })
        },


        fn_goBack: function(){
            this.$router.go(-1);
        },

    },
    mounted: function () {
        window.js_globals.fn_onBackPress = this.fn_goBack;
    }
    // beforeRouteLeave (to, from, next) {
    //     var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
    //     if(dialogData && dialogData.length){
    //         dialogjs.fn_checkAndCloseOpenDialogs(this);
    //         next(false);
    //     }
    //     else{
    //         next();
    //     }
    // }
  }
</script>


// WEBPACK FOOTER //
// src/components/settings/business/accountant_profile_settings.vue